
// stepper.config.ts
export interface StepConfig {
  id: number;           // step number
  label: string;        // text to show
  path: string | string[];         // router path for the step
}

export const STEPS: StepConfig[] = [
  { id: 1, label: '本人確認',            path: '/user-identification' },
  { id: 2, label: '必要書類の確認',      path: '/required-document' },
  { id: 3, label: '書類の提出',          path: '/document-submission' },
  { id: 4, label: '病気・ケガの状況確認', path: '/medical-assessment' },
  { id: 5, label: '追加情報の入力',      path: ['/bank-account', '/address-search', '/confirm-address'] },
];
